import Task from "./task";

export default class Todo extends Task {
    category = 'DEFAULT_CHECKLIST_ITEM'
}